import { render, staticRenderFns } from "./AboutUsForm.vue?vue&type=template&id=5560d284"
import script from "./AboutUsForm.vue?vue&type=script&lang=js"
export * from "./AboutUsForm.vue?vue&type=script&lang=js"
import style0 from "./AboutUsForm.vue?vue&type=style&index=0&id=5560d284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports